import AddListingTwoStepModal from "../Modals/AddListingTwoStepModal";
import AddListingTwoStepDrawer from "../Drawers/AddListingTwoStepDrawer";
import { useState } from "react";
import { OhButton } from "~/components/ui/custom-radix-components/button";
import { UniqueVisitorModal } from "../Modals/UniqueVisitorModal/UniqueVisitorModal";
import Cookies from "js-cookie";

export default function HelpCard({
    buttonText,
    heading,
    description,
    img,
    alt,
    country,
    searchUrl
}: {
    buttonText: string;
    heading: string;
    description: string;
    img: string;
    country: string;
    searchUrl?: string;
    alt: string;
}) {
    const [addListing, setAddListing] = useState(false);
    const [uniqueVisitorModal, setUniqueVisitorModal] = useState(false);
    const isClient = typeof window !== "undefined";
    const screenWidth = isClient
        ? parseInt(Cookies.get("screenWidth") || "0", 10)
        : 1024;
    const isMobile = screenWidth > 0 && screenWidth < 768;

    return (
        <div className="relative rounded-lg overflow-hidden border border-gray-200 p-4 bg-white">
            {/* Background image */}
            <img
                src={img}
                alt={alt}
                width={600}
                height={300}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover"
            />

            {/* White overlay effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-white/100 to-white/50" />

            {/* Content */}
            <div className="relative z-10 p-6 flex flex-col h-full justify-center">
                <h2 className="text-3xl text-oh-black font-bold mb-2 w-full md:w-1/2">
                    {heading}
                </h2>
                <p className="mb-2 text-base text-oh-black">{description}</p>

                {searchUrl ? (
                    <OhButton
                        onClick={() => setUniqueVisitorModal(true)}
                        variant="secondary" className="px-4 py-2 w-max-content rounded font-medium shadow transition">
                        {buttonText}
                    </OhButton>
                ) : (
                    <OhButton
                        variant="secondary"
                        onClick={() => setAddListing(true)}
                        className="px-4 py-2 w-max-content rounded font-medium shadow transition"
                    >
                        {buttonText}
                    </OhButton>
                )}
            </div>

            {/* Modal */}
            {addListing && (
                isMobile ? (
                    <AddListingTwoStepDrawer onClose={() => setAddListing(false)} />
                ) : (
                    <AddListingTwoStepModal onClose={() => setAddListing(false)} />
                )
            )}
            {
                uniqueVisitorModal && (

                    <UniqueVisitorModal visible={uniqueVisitorModal} params={null} handleCancel={() => setUniqueVisitorModal(false)} handleSubmit={() => setUniqueVisitorModal(false)} region={country} />
                )
            }

        </div >
    );
}
